import { DirectionalLight, PointLight } from 'three'
import { isDirectionalLight } from './type-guards'
import {
  BaseLightConfig,
  DirectionalLightConfig,
} from '../../../../trillion-common/src/objects/light-config.object'

export function createConfigFromLight(lightObj: DirectionalLight | PointLight) {
  const lightConfig = isDirectionalLight(lightObj)
    ? new DirectionalLightConfig({
        target: lightObj.target.position,
        color: lightObj.color.getHex(),
        intensity: lightObj.intensity,
        position: lightObj.position,
        name: lightObj.name,
        type: 'DirectionalLight',
      })
    : new BaseLightConfig({
        color: lightObj.color.getHex(),
        intensity: lightObj.intensity,
        position: lightObj.position,
        name: lightObj.name,
        type: 'PointLight',
      })

  return lightConfig
}
